// extracted by mini-css-extract-plugin
export var Mock = "styles-module--Mock--39tPZ";